/** @typedef {'welcome' | 'dashboard' | 'createProject' | 'analysis' | 'report' | 'settings'} TourId */

/** @typedef {'completed' | 'skipped' | 'pending'} TourStatus */

export const ONBOARDING_ATTR = 'data-onboarding';

/** @type {Record<string, TourId>} */
export const TOUR_IDS = {
  WELCOME: 'welcome',
  DASHBOARD: 'dashboard',
  CREATE_PROJECT: 'createProject',
  ANALYSIS: 'analysis',
  REPORT: 'report',
  SETTINGS: 'settings',
};

/** @type {TourId[]} */
export const ALL_TOUR_IDS = Object.values(TOUR_IDS);

/** @type {Record<TourId, string>} */
export const TOUR_I18N_KEYS = {
  welcome: 'tour.names.welcome',
  dashboard: 'tour.names.dashboard',
  createProject: 'tour.names.createProject',
  analysis: 'tour.names.analysis',
  report: 'tour.names.report',
  settings: 'tour.names.settings',
};

/** @type {Record<string, TourId[]>} */
export const PERSONA_TOURS = {
  investisseur: ALL_TOUR_IDS,
  courtier_immo: ALL_TOUR_IDS,
  courtier_hypo: ALL_TOUR_IDS,
  preteur_prive: ALL_TOUR_IDS,
};

export const STORAGE_KEY_PREFIX = 'rentalyzer.tourProgress.';
export const FAB_PULSE_KEY_PREFIX = 'rentalyzer.tourFabPulseSeen.';

/**
 * @param {string} id
 * @returns {string}
 */
export function onboardingSelector(id) {
  return `[${ONBOARDING_ATTR}="${id}"]`;
}

/** @type {import('driver.js').Config} */
export const BASE_DRIVER_CONFIG = {
  animate: true,
  overlayOpacity: 0.55,
  smoothScroll: true,
  stagePadding: 8,
  stageRadius: 8,
  allowClose: true,
  showProgress: false,
  popoverClass: 'rentalyzer-tour-popover',
  showButtons: ['next', 'previous', 'close'],
  overlayClickBehavior: 'close',
  disableActiveInteraction: false,
};

/** Driver.js overlay z-index — above header, below floating docks at z-200 */
export const DRIVER_OVERLAY_Z_INDEX = 150;
